<template>
    <div>
        <AmountDigitInput v-if="isInput" v-model="inputValue" :disabled="disabled" nullable @blur="priceChange"/>
        <span class="text-1" v-else-if="setType == 1">{{formatedValue}}</span> 
        <span class="text-2" v-else-if="setType == 2">**{{formatedValue}}</span>
        <span class="text-2" v-else>*{{formatedValue}}</span>
    </div>
</template>

<script>
export default {
    props: {
        isInput: {
            type: Boolean,
            default: false,
        },
        setType: { // 0:默认折扣计算显示是灰色斜体带一个*，1:手工修改显示是黑体， 2:默认加减计算的灰色斜体带两个*
            type: String | Number,
            default: 1,
        },
        value: {
            type: String | Number,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            inputValue: this.value
        };
    },
    computed: {
        formatedValue() {
            return this.$utils.amountDigitFn(this.inputValue);
        },
    },
    watch: {
        value(val) {
            this.inputValue = val;
        }
    },
    methods: {
        priceChange(/* value: blur event */) {
            if (this.inputValue == this.value) return;
            this.$emit('change', this.inputValue);
        },
    },
};
</script>

<style scoped lang="scss">
// .text-1 {
// }
.text-2 {
    color: darkgray;
    text-decoration: underline;
    font-style: oblique;
}
</style>